import { Typography } from 'antd';

import { LogsGenerator } from '@app/components/LogsGenerator';
import {
  useRecordHistory,
  useRecordHistoryEffects,
} from '@app/components/RecordModal/components/RecordHistory/hooks';
import type { ContentPropsType } from '@app/components/RecordModal/types';
import '@app/components/RecordModal/components/RecordPayment/styles/RecordPayment.desktop.scss';

const PF = 'record-payment';
const { Title } = Typography;

export const RecordHistory: ContentPropsType = () => {
  const { fetchRecordHistory, actions } = useRecordHistory();
  useRecordHistoryEffects({ fetchRecordHistory });

  return (
    <div className={`${PF}_container`}>
      <Title className={`${PF}_title`} level={4} data-testid="changes-history">
        История изменений
      </Title>
      <div className={`${PF}_content`}>
        <LogsGenerator actions={actions} isEmployee={false} />
      </div>
    </div>
  );
};
